/** localStorage that never throws (private mode, blocked storage). For preferences only. */
export const localStore = {
  get(key: string): string | null {
    try {
      return window.localStorage.getItem(key);
    } catch {
      return null;
    }
  },
  set(key: string, value: string | null): void {
    try {
      if (value === null) window.localStorage.removeItem(key);
      else window.localStorage.setItem(key, value);
    } catch {
      // preferences are a convenience: ignore
    }
  },
};

export const STORE_KEYS = {
  language: 'lbm.language',
  location: (userId: string) => `lbm.location.${userId}`,
} as const;
